<template>
    <div class="rent">
        <servicesList></servicesList>
        <div class="rent_content" v-if="isEmptyData" v-html="htmlDecode(this.rentContent.content)"></div>
        <div style='width: 100%;text-align: center;margin: 75px 0 ;' v-else><img
                src='../../assets/images/no_page.png' alt='没有数据' width="160"></div>

    </div>
</template>

<script>
    import servicesList from '../../components/services/servicesList';

    export default {
        name: "rent",
        data: function () {
            return {
                isEmptyData: true,
                left: '',
                rentContent: ''
            }
        },
        components: {
            servicesList
        },
        created: function () {
            this.getRentInfo();
            this.$store.commit("set_current_index", 10);
            this.$store.commit("set_current", 5);
            this.$store.commit("set_title", 'nav.service');
        },
        methods: {
            getRentInfo: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/serve/getLease",
                    dataType: "json",
                    data:{
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            if (!res.data.result.content) {
                                this.isEmptyData = false;
                            } else {
                                this.isEmptyData = true;
                                this.rentContent = res.data.result;
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }

        },
        computed: {
            service_list: function () {
                return this.$store.state.service.service_list;
            },
            weburl: function () {
                return this.$store.state.weburl;
            }
        }


    }
</script>

<style scoped lang="less">
    .rent {
        width: 100%;
        background: #f0f0f0;
        padding-bottom: 1px;
        @media (min-width: 411px) {
            min-height: 527px;
        }
        @media (max-width: 375px) {
            min-height: 463px;
        }
        @media (max-width: 360px) {
            min-height: 426px;
        }
        @media (max-width: 320px) {
            min-height: 348px;
        }
    }



</style>
<style scoped>
    .rent_content >>> img {
        vertical-align: bottom;
        max-width: 100%;
    }
</style>
